import React from "react";
import { useTranslation } from "react-i18next";

const fileLimit = 200;
import SvgIcon from "../SvgIcon";
import { truncateVideoText } from "../../utils/string-helpers";

function VideoFieldLabel({ children, showMissing, className = "" }) {
  return (
    <label
      className={`sub-label Add-Exercise-metadataField-label ${className}`.trim()}
    >
      <span>{children}</span>
      {showMissing ? (
        <SvgIcon
          src="/img/new-icons/chip-warning.svg"
          classNames="Add-Exercise-metadataField-warningIcon"
          noFilterOnLight
        />
      ) : null}
    </label>
  );
}

const VideoUpload = ({
  videoFile,
  videoUrl,
  videoOriginal,
  handleInputChange,
  cleanVideoField,
  form,
  showMissingIndicators = false,
}) => {
  const { t } = useTranslation("coaching-portal");
  const [isOutOfLimit, setIsOutOfLimit] = React.useState(false);

  const showDisableVideoInputClassUrl = !!videoUrl ? "disable-video-input" : "";
  const urlLabelClass =
    !!videoFile || videoOriginal ? "disable-video-input" : "";

  const renderUrlLabel = () => {
    const text = t("videoUpload.exerciseUrl");
    if (!showMissingIndicators) {
      return (
        <label className={`sub-label ${urlLabelClass}`}>{text}</label>
      );
    }
    return (
      <VideoFieldLabel showMissing className={urlLabelClass}>
        {text}
      </VideoFieldLabel>
    );
  };

  const renderUploadLabel = () => {
    const text = (
      <>
        {t("videoUpload.videoUploadLabel")}
        {isOutOfLimit ? t("videoUpload.fileTooBig") : null}
      </>
    );
    if (!showMissingIndicators) {
      return (
        <label className={`sub-label ${showDisableVideoInputClassUrl}`}>
          {text}
        </label>
      );
    }
    return (
      <VideoFieldLabel
        showMissing
        className={showDisableVideoInputClassUrl}
      >
        {text}
      </VideoFieldLabel>
    );
  };

  return (
    <div className="form-row">
      <div className="form-row-item">
        {renderUrlLabel()}
        <input
          className="url-input"
          type="text"
          name="videoUrl"
          placeholder={`${
            !!videoFile || videoOriginal ? "" : t("videoUpload.pasteLinkPlaceholder")
          }`}
          value={videoUrl || ""}
          onChange={handleInputChange}
          disabled={!!videoFile || videoOriginal}
          form={form}
        />
      </div>

      <div className="form-row-item">
        {renderUploadLabel()}
        <label
          className={`video-input${
            videoOriginal || videoFile ? " uploaded" : ""
          } ${showDisableVideoInputClassUrl}`}
        >
          <div>
            <SvgIcon
              src={
                videoOriginal || videoFile
                  ? "/img/new-icons/Video.svg"
                  : "/img/new-icons/upload-file.svg"
              }
              noFilterOnLight={videoOriginal || videoFile ? false : true}
            />{" "}
            {videoOriginal || videoFile
              ? `${
                  truncateVideoText(videoOriginal) ||
                  truncateVideoText(
                    videoFile.split("\\")[videoFile.split("\\").length - 1]
                  )
                }`
              : t("videoUpload.chooseFile")}
          </div>
          {(videoOriginal || videoFile) && (
            <button
              data-button-type="secondry"
              data-icon-only={true}
              data-icon={true}
              onClick={(e) => {
                e.preventDefault();
                cleanVideoField();
              }}
            >
              <SvgIcon
                src="/img/new-icons/red-trash.svg"
                noFilterOnLight={true}
              />
            </button>
          )}
          <input
            className={`text-input file-input-other-form ${showDisableVideoInputClassUrl}`}
            type="file"
            name="videoFile"
            accept="video/*"
            disabled={!!videoUrl}
            onChange={(e) => {
              if (e?.target?.files[0]?.size > fileLimit * 1024 * 1024) {
                setIsOutOfLimit(true);
                e.target.value = "";
                return;
              }
              setIsOutOfLimit(false);

              handleInputChange(e);
            }}
            form={form}
          />
        </label>
        {/* )} */}
      </div>
    </div>
  );
};

export default VideoUpload;
